import {
	CREATE_DANDOS_FAILURE,
	FETCH_DANDO_SUCCESS,
	FETCH_DANDOS_SUCCESS,
	SELECT_DANDO,
	FETCH_CASE,
	DANDO_UPDATE,
	DANDO_CREATE_FORM
} from "./actions";

const initialState = {
	currently_loading_dandos: false,
	dandos_in_current_page: [],
	current_page: 0,
	total_dandos: 0,
	total_pages: 0,
	new_dando_error: null,
	new_dando_request: {
		dando_name: null,
		ticker: null,
		risk_assessment_date: null,
		notes:null
	},
	selected_dando: {},
	selected_case: {}
};


const reducerDandO = (state = initialState, action) => {
	switch (action.type) {
		case FETCH_DANDOS_SUCCESS:
			return {
				...state,
				current_page: action.page,
				dandos_in_current_page: action.data,
				total_pages: action.total_pages
			};
		case SELECT_DANDO:
			return {...state, selected_dando: {id: action.id}};
		case FETCH_CASE:
			return {
						...state, 
						selected_case :  action.data
					};
		case FETCH_DANDO_SUCCESS:
			let response = action.data;
			return {
				...state, selected_dando: {
					id: action.id,
					riskAssessmentDate: response.riskAssessmentDate,
					dateAdded: response.dateAdded,
					lastUpdate: response.lastUpdate,
					companyName: response.companyName,
					symbol: response.symbol,
					status: response.status,
				}
			};
		case CREATE_DANDOS_FAILURE:
			return {
				...state,
				new_dando_error: action.error
			};

		case DANDO_UPDATE:
			return {
				...state,
				UpdateDandOResult: action.UpdateDandOResult
			};
		case DANDO_CREATE_FORM:
			return {
					...state,
					new_dando_request:action.dandoForm
			}
		default:
			return state
	}
};


export default reducerDandO;


// WEBPACK FOOTER //
// ./src/dandos/redux/reducers.js